export default __webpack_public_path__ + "static/media/favourited.e5af9b37.svg";